import React, { memo } from 'react';
import { AlertTriangle } from 'lucide-react';
interface ClientStatusBannerProps {
  status: string;
}
export function ClientStatusBanner({
  status
}: ClientStatusBannerProps) {
  if (status !== 'Non attivo') return null;
  return <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 rounded-r-xl shadow-sm" data-id="element-72">
      <div className="flex items-start" data-id="element-73">
        <div className="flex-shrink-0" data-id="element-74">
          <AlertTriangle className="h-5 w-5 text-red-500" aria-hidden="true" data-id="element-75" />
        </div>
        <div className="ml-3" data-id="element-76">
          <h3 className="text-sm font-bold text-red-800" data-id="element-77">Cliente NON ATTIVO</h3>
          <div className="mt-2 text-sm text-red-700" data-id="element-78">
            <p data-id="element-79">
              Le automazioni per questo cliente sono disabilitate. Non verranno
              inviate email, notifiche o promemoria automatici.
            </p>
            <ul className="list-disc list-inside mt-1 text-xs opacity-80" data-id="element-80">
              <li data-id="element-81">Invio attestati formazione bloccato</li>
              <li data-id="element-82">Alert scadenze disabilitati</li>
              <li data-id="element-83">Workflow fatturazione sospeso</li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}